// Corevive Magnesium TriMag - single product mock data

export const LOGO_URL = 'https://customer-assets-v7afamib.emergentagent.net/job_gods-realm/artifacts/ehrn7rzw_IMG_0751.jpeg';
export const PRODUCT_IMAGE = 'https://customer-assets-v7afamib.emergentagent.net/job_gods-realm/artifacts/jq0ilyet_IMG_0225.webp';

export const brand = {
  name: 'COREVIVE',
  tagline: 'Own Your Strength.',
  accent: '#1FB6C1',
  accentDark: '#118A94',
};

export const announcement = {
  text: 'Free shipping across India on orders above',
  amount: '\u20b9999',
  suffix: '. 100% third-party lab tested. Made in India.',
  contactPhone: '+91 89260 80709',
  contactEmail: 'hello@corevive.in',
};

export const promoStrip = [
  'India\u2019s First Triple Magnesium Complex',
  '320 mg Elemental Magnesium',
  'With Vitamin D3 + B12',
  'Third-Party Lab Tested',
  'Own Your Strength',
];

export const product = {
  id: 'trimag-60',
  name: 'Magnesium TriMag\u2122',
  subtitle: '320 mg Elemental Magnesium \u2022 Triple Magnesium Formula',
  short: 'Supports Muscle Recovery, Sleep Quality & Nerve Function.',
  image: 'https://customer-assets-v7afamib.emergentagent.net/job_gods-realm/artifacts/jq0ilyet_IMG_0225.webp',
  quantity: '60 Tablets',
  servings: '30 Servings',
  rating: 4.8,
  reviews: 214,
  variants: [
    { id: 'v1', label: 'One-Time', qty: '1 Bottle \u2022 60 Tablets', price: 1299, compareAt: 1599, badge: null },
    { id: 'v2', label: 'Subscribe & Save 15%', qty: '1 Bottle every 30 days', price: 1104, compareAt: 1599, badge: 'Most Popular' },
    { id: 'v3', label: 'Bundle x2', qty: '2 Bottles \u2022 120 Tablets', price: 2299, compareAt: 3198, badge: 'Best Value' },
  ],
};

export const benefits = [
  { id: 'muscle', icon: 'Dumbbell', title: 'Muscle Recovery', desc: 'Reduces post-workout soreness and cramps. Magnesium regulates muscle contractions so you bounce back faster.' },
  { id: 'sleep', icon: 'Moon', title: 'Deep Sleep', desc: 'Glycinate & liposomal forms calm the nervous system for deeper, uninterrupted sleep and restful mornings.' },
  { id: 'nerve', icon: 'Zap', title: 'Nerve Function', desc: 'Supports nerve signaling, focus, and stress response. Feel calm, alert and dialed in throughout the day.' },
  { id: 'bone', icon: 'ShieldCheck', title: 'Bone & Heart', desc: 'Aquamin\u00ae marine magnesium supports bone density and healthy cardiovascular rhythm.' },
];

export const formula = [
  { id: 'glycinate', name: 'Magnesium Glycinate', role: 'Calm & Sleep', desc: 'Bound to glycine for gentle absorption. Best-in-class for sleep, stress relief and next-day recovery.', dose: '150 mg' },
  { id: 'aquamin', name: 'Aquamin\u00ae Marine Magnesium', role: 'Bone & Muscle', desc: 'Multi-mineral seawater complex clinically shown to support bone density and joint comfort.', dose: '100 mg' },
  { id: 'lipoza', name: 'Lipoza\u00ae Liposomal Magnesium', role: 'Absorption', desc: 'Phospholipid-encapsulated for up to 3.5\u00d7 higher bioavailability than standard oxide forms.', dose: '70 mg' },
];

export const additives = [
  { name: 'Vitamin D3', desc: 'Improves magnesium & calcium absorption.' },
  { name: 'Vitamin B12', desc: 'Supports energy metabolism and nerve health.' },
];

export const comparison = {
  headers: ['', 'Corevive TriMag', 'Ordinary Magnesium'],
  rows: [
    ['Elemental Magnesium', '320 mg', '~ 100\u2013200 mg'],
    ['Absorption Rate', 'Up to 3.5\u00d7 higher', 'Low (Oxide ~4%)'],
    ['Forms in Formula', 'Glycinate + Aquamin + Liposomal', 'Single form'],
    ['Added D3 + B12', 'Yes', 'No'],
    ['Gentle on Stomach', 'Yes', 'Often causes issues'],
    ['Third-Party Tested', 'Yes', 'Rarely'],
  ],
};

export const timeline = [
  { day: 'Day 1\u20137', title: 'Calm Nights', desc: 'Fall asleep faster. Wake up less. Stress dips.' },
  { day: 'Day 8\u201321', title: 'Fewer Cramps', desc: 'Post-workout soreness eases. Legs stop twitching at night.' },
  { day: 'Day 22\u201360', title: 'Full System Reset', desc: 'Steadier energy, clearer focus, stronger recovery cycles.' },
];

export const testimonials = [
  { name: 'Arjun M.', role: 'Powerlifter, Bengaluru', text: 'My leg cramps used to wake me up 3 nights a week. Three weeks on TriMag and they\u2019re just\u2026 gone. Sleep quality is a whole different story now.', rating: 5 },
  { name: 'Priya S.', role: 'Marathon runner, Mumbai', text: 'The only magnesium that doesn\u2019t upset my stomach. I feel calmer during long runs and my HRV has improved noticeably.', rating: 5 },
  { name: 'Karan V.', role: 'Founder, Delhi', text: 'I sleep 6\u20137 hours but wake up feeling like I slept 9. Focus during meetings is night and day.', rating: 5 },
  { name: 'Neha R.', role: 'Yoga instructor, Pune', text: 'Finally an Indian brand that doesn\u2019t hide the doses. 320mg elemental is what actually works.', rating: 5 },
];

export const faqs = [
  { q: 'When should I take Corevive TriMag?', a: 'Take 2 tablets 30\u201360 minutes before bed with water. For active days, you can also split \u2014 1 tablet post-workout and 1 tablet before sleep.' },
  { q: 'Is it safe to take daily?', a: 'Yes. 320 mg elemental magnesium sits within the recommended daily range for healthy adults. Consult your physician if you are pregnant, nursing or on medication.' },
  { q: 'How is TriMag different from regular magnesium?', a: 'Most cheap magnesium supplements use oxide, which absorbs at only ~4%. TriMag combines three high-absorption forms (Glycinate, Aquamin marine, Lipoza liposomal) with D3 + B12 for a compounding effect.' },
  { q: 'How long until I feel results?', a: 'Most customers notice calmer nights within the first week. Full recovery, sleep and focus benefits build over 3\u20134 weeks of consistent use.' },
  { q: 'Is it vegetarian?', a: 'Yes. TriMag is 100% vegetarian and made in a GMP-certified facility in India. Third-party tested for heavy metals, purity and potency.' },
  { q: 'What is your return policy?', a: 'Try TriMag risk-free for 30 days. Not for you? Email hello@corevive.in and we\u2019ll refund your first bottle \u2014 no questions asked.' },
];

export const footerLinks = {
  shop: ['Magnesium TriMag', 'Coming Soon: Sleep+', 'Coming Soon: Recovery'],
  care: ['FAQs', 'Shipping', 'Returns', 'Track Order', 'Lab Reports'],
};
